import { OnOffSwitch, OnOffSwitchSize } from "@similarweb/ui-components";
import type { IOnOffSwitchProps } from "@similarweb/ui-components";

import { StyledOnOffSwitchGroup } from "./styles";

type Props = Omit<IOnOffSwitchProps, "size" | "onLabel" | "offLabel"> & {
    label: string;
};

const OnOffSwitchGroup = ({ label, ...switchProps }: Props) => {
    return (
        <StyledOnOffSwitchGroup data-automation="filter-switch">
            <OnOffSwitch
                size={OnOffSwitchSize.small}
                onLabel={label}
                {...switchProps}
            />
        </StyledOnOffSwitchGroup>
    );
};

export default OnOffSwitchGroup;
